import {Component, Input} from '@angular/core';
import {ContactPerson} from "../../interfaces/contact-person";

@Component({
  selector: 'brt-contact-person',
  templateUrl: './contact-person.component.html',
  styleUrls: ['./contact-person.component.scss']
})
export class ContactPersonComponent {

  @Input('contactPerson') set setContactPerson(val: ContactPerson) {
    // if(!val.avatar || val.avatar.length === 0) {
    //   val.avatar = '/assets/img/icons/SUBEJCT=Avater Placeholder.svg';
    // }

    this.contactPerson = val;
  }

  contactPerson!: ContactPerson;

  getContactIcon(type: string) {
    switch (type) {
      case 'TELB':
      case 'MOBB':
        return 'phone';
      case 'MAILB':
        return 'social-email';
      default:
        return 'dotting';
    }
  }

  getContactLink(type: string, value: string) {

    let prefix = "";

    switch (type) {
      case 'TELB':
      case 'MOBB':
        prefix = 'tel:';
        break;
      case 'MAILB':
        prefix = 'mailto:';
        break;
      default:
        break;
    }

    return prefix + value.replace(" ", "");
  }
}
